<div class="wrapper" *ngIf="show">
    <div class="message">
        <span [ngStyle]="{'color': textColor, 'background-color': shade1}">{{message}}</span>
    </div>
</div>
